import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import {
  fetchCircleAuthToken,
  fetchSpaceListV2,
  onGetCircleAuthToken,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

export const loadData = (params, search) => async (dispatch, getState) => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };

  const { currentUser } = getState().user;
  try {
    if (!currentUser) {
      await dispatch(fetchCurrentUser());
    }
  } catch (e) {
    console.log(e, '&&& &&& => e');
  }

  const email = currentUser?.attributes?.email;
  const { access_token, community_member_id } = await onGetCircleAuthToken(email);
  if (access_token) {
    dispatch(fetchSpaceListV2());
  }

  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(fetchCircleAuthToken({})),
  ]);
  return dispatch(fetchPageAssets(pageAsset, true));
};
